<div>
    <ul class="nav nav-tabs nav-justified" role="tablist">
        <li role="presentation"
            [ngClass]="{'active': isSelectedAllAgency()}">
            <a (click)="selectAllAgencies()" role="tab" data-toggle="tab">
                <h3>{{'session-calendar.all-locations' | translate}}</h3>
            </a>
        </li>
        <li *ngFor="let agency of agencies; let i = index;" role="presentation"
            [class]="'agency-name ' + colorStyle(agency)"
            [ngClass]="{'active': isSelectedAgency(agency.id)}">
            <a (click)="selectAgency(agency.id)" role="tab" data-toggle="tab">
                <h3 *ngIf="agency.name">{{agency.name}}</h3>
                <h3 *ngIf="!agency.name">{{'session-calendar.no-location' | translate}}</h3>
            </a>
        </li>
    </ul>
</div>


// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/agency/agency.component.html